import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import MainContent from "./mainContent";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useParams, useNavigate } from "react-router-dom";
import {
  changeRequestStatusUpdate,
  getChangeRequestDetails,
} from "../../api/casp/changeRequest";
import { toast } from "react-toastify";
import Loader from "../../Components/Common/Loader";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { ChangeRequestStatus } from "../../constants/Status";
import { Modules } from "../../constants/Module";
import { useSelector } from "react-redux";
import { ChangeRequestStatusColor } from "../../constants/ChangeRequestStatus";
import DescriptionIcon from "@mui/icons-material/Description";
import ShowCommentModal from "../../Components/casp/common/ShowCommentModal";
import { Helmet } from 'react-helmet';
import { filter } from 'lodash/collection'
import { get } from 'lodash/object'
import { getIconPath } from "../../helpers/file_helper";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import { withTranslation } from "react-i18next";
import ContentInfo from "../../common/contentInfo";

const ViewChangeRequest = (props) =>{
  const [changeRequestDetails, setChangeRequestDetails] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const { changeRequest } = useParams();
  const [openRejectModel, setOpenRejectModel] = useState(false);
  const loggedInUser = useSelector((state) => state.Profile.user);
  const navigate = useNavigate();
  const [rejectReason, setRejectReason] = useState();
  const [trigger, setTrigger] = useState(new Date())
  const { project } = useParams()

  useEffect(() => {
    if (changeRequest) {
      fetchChangeRequestDetails();
    }
  }, []);

  const fetchChangeRequestDetails = async () => {
    try {
      setIsLoading(true);
      const res = await getChangeRequestDetails(changeRequest, {projectId: parseInt(project)});
      setChangeRequestDetails(res.data.data);
      setTrigger(+new Date())
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpen = (comment, data) => {
    setOpenRejectModel(true);
    setRejectReason({
      name: data?.name,
      profilePicture: data?.profilePicture,
      role:data?.projectUsers[0]?.role?.name ?? '',
      comment,
    });
  };

  const handleRejectModal = () => {
    setOpenRejectModel(!openRejectModel);
    setRejectReason();
  };

  return (
    <React.Fragment>
      <div className="page-content change-req-pg position-relative">

      <Helmet
                onChangeClientState={(newState, addedTags) => {
                  try {
                  // Check if we added any new link[rel="icon"] elements.
                  const newFaviconElems = filter(get(newState, 'linkTags', []), {
                      rel: 'icon',
                  })

                  if (!newFaviconElems.length) {
                      return
                  }

                  // Get the href of the last link element we just added, which
                  // we assume is the most recently-added favicon.
                  const newFaviconHref =
                      newFaviconElems[newFaviconElems.length - 1].href

                  // Remove all react-helmet link elements with rel="icon" that
                  // do not have the href of our recently-added favicon.
                  // If no other favicon elements exist, we don't have to do
                  // anything.
                  const existingFavicons = document.querySelectorAll(
                      `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
                  )

                  if (existingFavicons.length) {
                      existingFavicons.forEach(e => e.parentNode.removeChild(e))
                  }

                  // Remove and re-add the latest link element to make sure
                  // the browser uses it.
                  const newFaviconElem = document.querySelector(
                      `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
                  )

                  if (newFaviconElem) {
                      const newFavElement = newFaviconElem.cloneNode(true)
                      newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                          `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(<PublishedWithChangesIcon />)}</svg>`
                        )}`
                      const parentElem = newFaviconElem.parentNode
                      parentElem.removeChild(newFaviconElem)
                      parentElem.appendChild(newFavElement)
                  }
                  } catch (e) {
                  console.error(e)
                  }
              }}
      >
            <title>{props.t('Update Change Request')}</title>
      </Helmet>
        <Container fluid>
          <div className="viewProjApprovalPg mainPageHeader d-flex justify-content-between mb-3">
            <BreadCrumb title={props.t("View Details")} />
            {loggedInUser.id === changeRequestDetails?.creator?.id && (
              <div className="projApprovalActions">
                <div className={`statusBadge ${ChangeRequestStatusColor(changeRequestDetails.status)} badge-outlined text-capitalize mx-1`}>
                  {changeRequestDetails.status ===
                  ChangeRequestStatus.IN_APPROVAL
                    ? "pending"
                    : changeRequestDetails.status}
                  {changeRequestDetails.status === ChangeRequestStatus.IN_APPROVAL &&
                    <ContentInfo content={changeRequestDetails?.latestApproval?.currentApprovalUser}/>
                  }
                  {changeRequestDetails.status ===
                    ChangeRequestStatus.REJECTED && (
                    <DescriptionIcon
                      style={{ cursor: "pointer", height:'18px' }}
                      onClick={() =>
                        handleOpen(
                          changeRequestDetails.previousApproval?.comments,
                          changeRequestDetails.previousApproval
                            ?.currentApprovalUser?.user
                        )
                      }
                    />
                  )}
                </div>
              </div>
            )}
          </div>
          <div className="project_select_name w-100">
            {changeRequestDetails && (
              <Accordion className="changeReqMainContent" defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {changeRequestDetails?.project?.name}
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  {changeRequestDetails && (
                    <MainContent key={trigger} changeRequestDetails={changeRequestDetails} emit={fetchChangeRequestDetails}/>
                  )}
                </AccordionDetails>
              </Accordion>
            )}

            {isLoading && <Loader />}
          </div>
        </Container>
      </div>

      <div className="rejectModal">
        <ShowCommentModal
          handleRejectModal={handleRejectModal}
          open={openRejectModel}
          module={Modules.CHANGE_REQUEST}
          data={rejectReason}
        />
      </div>
    </React.Fragment>
  );
}

export default withTranslation() (ViewChangeRequest)
